<template>
  <div class="site-contents container event-lists">
    <h2 class="mt-3">Payment History</h2>
    <div class="row">
      <div class="col">
        <table
          id="payment-history"
          class="display table-striped nowrap dataTable"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th>S.N</th>
              <th>Id</th>
              <th>Date</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Quantity</th>
              <th>Payment Method</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
@import "//cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css";
th {
  color: #6d5b97 !important;
  font-weight: 500 !important;
}
#payment-history_filter,
#payment-history_length {
  padding: 30px 0px 20px 0px;
  display: inline-block;
  margin-left: 1em;
}
.col {
  color: #3f3d55;
  padding-bottom: 150px;
}
td {
  padding: 20px !important;
}
tr.odd {
  background: #f9f3ff !important;
}
table,
thead {
  border-bottom: 1px solid #6d5b97;
}
.paginate_button.current {
  background: #f9f3ff !important;
  color: #fff !important;
}
.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  background: #f9f3ff !important;
  color: #333 !important;
  border: 1px solid #333 !important;
}
</style>
<script>
import { dataTableInterceptor } from "../../helpers/datatable-service";
export default {
  data() {
    return {
      purchaseTable: null,
      _id: "",
      user: "",
      type: "",
      amount: "",
      date: "",

      purchaseCount: "",
      eventsUsed: ""
    };
  },
  mounted() {
    let loadDatatable = document.createElement("script");

    loadDatatable.setAttribute(
      "src",
      "//cdn.datatables.net/1.10.20/js/jquery.dataTables.min.js"
    );
    loadDatatable.async = true;
    loadDatatable.defer = true;
    document.head.appendChild(loadDatatable);

    //inititate datatable
    loadDatatable.onload = function() {
      //set config params
      let params = {
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        deferRender: true,
        serverSide: true,
        responsive: true,
        processing: true,
        order: [[2, "desc"]],
        language: {
          emptyTable: "No payments found.",
          sLengthMenu: "_MENU_",
          search: "",
          processing: '<div class="spinner-border spinner-middle"></div>'
        },
        fnServerData: function(sSource, aoData, fnCallback, oSettings) {
          return dataTableInterceptor(
            sSource,
            aoData,
            fnCallback,
            oSettings,
            `/purchase/paymentHistory`
          );
        },
        columns: [
          { data: "sn", sortable: false },
          { data: "_id", sortable: false },
          { data: "date" },
          { data: "type" },
          { data: "amount" },
          { data: "purchaseCount" },
          // { data: "eventsUsed" },
          { data: "receiptData" }
        ],
        columnDefs: [
          {
            targets: 0,
            orderable: true,
            render: function(data, type, row, meta) {
              //data has _id
              return meta.row + 1 + meta.settings._iDisplayStart;
            }
          }
        ]
      };

      //load datatable
      $("#payment-history").DataTable(params);
      $(".dataTables_filter input,.dataTables_length select").addClass(
        "form-control"
      );
      $(".dataTables_filter input").attr("placeholder", "Search payments");
    };
  },
  methods: {}
};
</script>
